import { Card, Row, Col } from "react-bootstrap";

interface IProps {
  title: string;
  subTitle: string;
  itemCount?: number;
  itemText?: string;
  children: any;
}

export default function CardContainer({ title, subTitle, itemCount, itemText, children }: IProps) {
  return (
    <div className="container-fluid mt-3">
      <Card className="shadow-sm">
        <Card.Header className="bg-primary text-white">
          <Row className="align-items-center">
            <Col>
              <h3 className="mb-0 text-white fw-bold">
                <i className="fas fa-tachometer-alt me-2"></i>
                {title}
              </h3>
              <small className="text-white-50">{subTitle}</small>
            </Col>
            {itemCount && itemText && (
              <Col xs="auto">
                <span className="badge bg-white text-primary">
                  {itemCount} {itemText}
                </span>
              </Col>
            )}
          </Row>
        </Card.Header>
        <Card.Body className="p-0">{children}</Card.Body>
      </Card>
    </div>
  );
}
